export enum UsageType {
    LOW = 'LOW',
    MEDIUM = 'MEDIUM',
    HIGH = 'HIGH',
}

export const LOW_USAGE_COLORS = ['#338800', '#64C038', '#DDE3EA'];
export const MEDIUM_USAGE_COLORS = ['#957200', '#F4BF1D', '#DDE3EA'];
export const HIGH_USAGE_COLORS = ['#900D00', '#E23119', '#DDE3EA'];
export const UNLIMITED_USAGE_COLORS = ['#00658D', '#83CFFF', '#DDE3EA'];